module.exports = __webpack_public_path__ + "static/media/DE6D1DD9-1502-4836-9E5C-5027B454620E.0fcb7392.PNG";